// removed by extract-text-webpack-plugin
module.exports = {"root":"TabList__root___2gVas","tab":"TabList__tab___2hDmV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseTabs/TabList/TabList.css
// module id = 966
// module chunks = 0